// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hardware-resource-gauge[data-v-613bfb4e]{position:relative;display:flex;flex-direction:column}.hardware-resource-gauge .hw-gauge[data-v-613bfb4e]:not(:first-of-type){margin-top:20px}.hardware-resource-gauge .values[data-v-613bfb4e]{font-size:12px;padding-left:10px}", ""]);
// Exports
module.exports = exports;
